/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 * Based on https://github.com/mattdesl/fontpath-shape2d
 */

import Shape2D from "App/utils/text/fonts/shape_2d";

export default
function decompose(glyph: any, options: any) {
    options = options || {};

    let curves = Boolean(options.approximateCurves);
    let steps = options.steps || 10;
    let factor = options.approximationFactor;
    factor = (typeof factor === "number") ? factor : 0.5;

    let shapes = [];
    let shape = new Shape2D();
    shape.approximateCurves = curves;
    shape.approximationFactor = factor;
    shape.steps = steps;

    if (!glyph.commands || glyph.commands.length === 0) {
        return shapes;
    }

    let funcs = {
        'M': 'moveTo',
        'L': 'lineTo',
        'Q': 'quadraticCurveTo',
        'C': 'bezierCurveTo',
        'Z': 'closePath'
    };


    let path = glyph.commands;
    for (let i = 0; i < path.length; i++) {
        let args = path[i];
        let fkey = funcs[args.type];

        //assume we are on a new shape when we reach a moveto
        //will have to revisit this with a better solution
        //maybe even-odd rule
        if (i !== 0 && fkey === 'moveTo') {
            //push the current shape ahead..
            shapes.push(shape);

            shape = new Shape2D();
            shape.approximateCurves = curves;
            shape.approximationFactor = factor;
            shape.steps = steps;
        }

        shape[fkey].apply(shape, [args, steps]);
    }

    shapes.push(shape);
    return shapes;
}
